import React, { useEffect, useState } from 'react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { IconButton, Popover, Box, TextField, InputAdornment } from '@material-ui/core';
import { DateRange as DateRangeIcon } from '@material-ui/icons';
import moment from 'moment';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const DateRangeSelector = ({
    selectedRange = [], // ex:- ["2023-07-10", "2023-07-13"]
    onChange,
    classes
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [dateRange, setDateRange] = useState([
        {
            startDate: getDateValue('start') || null,
            endDate: getDateValue('end') || null,
            key: 'selection'
        }
    ]);
    const [dateSelected, setDateSelected] = useState(false);

    useEffect(() => {
        if (onChange && dateSelected) {
            if (moment(moment(dateRange[0].startDate).toDate()).isValid() && moment(moment(dateRange[0].endDate).toDate()).isValid()) {
                let range = [];
                range.push(moment(dateRange[0].startDate).format('yyyy-MM-DD'), moment(dateRange[0].endDate).format('yyyy-MM-DD'));
                onChange(range);
                setDateSelected(false);
            }
            else if (moment(moment(dateRange[0].startDate).toDate()).isValid()) {
                let range = [];
                range.push(moment(dateRange[0].startDate).format('yyyy-MM-DD'));
                onChange(range);
                setDateSelected(false);
            }
        }
    }, [dateRange]);

    function getDateValue(type) { // converting saved date range dates to date objects
        if (selectedRange.length > 0 && moment(moment(selectedRange[0]).toDate()).isValid() && moment(moment(selectedRange[1]).toDate()).isValid()) {
            if (type === "start") {
                return moment(selectedRange[0]).toDate();
            } else {
                return moment(selectedRange[1]).toDate();
            }
        }
        return null;
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelect = (ranges) => {
        setDateSelected(true);
        setDateRange(ranges)
    };

    const open = Boolean(anchorEl);
    const id = open ? 'date-range-popover' : undefined;

    return (
        <>
            <Box className={classes.dateRangePicker}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <div>
                    <span className={classes.inputLabel}>Start Date</span>

                    <DatePicker
                        name={"startDate"}
                        aria-label={"startDate"}
                        variant="inline"
                        format="dd/MM/yyyy"
                        margin="normal"
                        value={dateRange[0].startDate}
                        onChange={(event) => {
                            if (event && moment(moment(event).toDate()).isValid()) {
                                handleSelect([
                                    {
                                        startDate: moment(event).toDate(),
                                        endDate: dateRange[0].endDate < moment(event).toDate() ? null : dateRange[0].endDate,
                                        key: 'selection'
                                    }
                                ]);
                            }
                        }}
                        autoOk
                        inputProps={{
                            'aria-label': "startDate"
                        }}
                        KeyboardButtonProps={{
                            "aria-label": "Open Calendar",
                        }}
                    />
                    </div>
   <div>
                    <span className={classes.inputLabel}>End Date</span>

                    <DatePicker
                        name={"endDate"}
                        aria-label={"endDate"}
                        variant="inline"
                        format="dd/MM/yyyy"
                        margin="normal"
                        minDate={dateRange[0].startDate}
                        value={dateRange[0].endDate}
                        onChange={(event) => {
                            if (event && moment(moment(event).toDate()).isValid()) {
                                handleSelect([
                                    {
                                        startDate: dateRange[0].startDate,
                                        endDate: moment(event).toDate(),
                                        key: 'selection'
                                    }
                                ]);
                            }
                        }}
                        autoOk
                        inputProps={{
                            'aria-label': "endDate"
                        }}
                        KeyboardButtonProps={{
                            "aria-label": "Open Calendar",
                        }}
                    />
                    </div>
                </MuiPickersUtilsProvider>
                {/*  <TextField
                    // placeholder='Start Date - End Date'
                    value={(dateRange[0].startDate && dateRange[0].endDate) ? `${dateRange[0].startDate?.toLocaleDateString("EN-GB")} - ${dateRange[0].endDate?.toLocaleDateString("EN-GB")}` : ''}
                    onClick={handleClick}
                    variant="outlined"
                    InputProps={{
                        readOnly: true,
                        endAdornment: <InputAdornment position="end">
                            <IconButton color="inherit" onClick={handleClick}>
                                <DateRangeIcon />
                            </IconButton>
                        </InputAdornment>
                    }}
                /> */}
            </Box>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                <Box p={2}>
                    <DateRange
                        ranges={(dateRange[0].startDate !== null && dateRange[0].endDate !== null) ? dateRange : [
                            {
                                startDate: new Date(),
                                endDate: new Date(),
                                key: 'selection'
                            }
                        ]}
                        onChange={handleSelect}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        retainEndDateOnFirstSelection={false}
                        months={2}
                        direction="horizontal"
                        dateDisplayFormat="dd/MM/yyyy"
                    />
                </Box>
            </Popover>
        </>
    );
};

export default DateRangeSelector;